import { convertGoogleTimeStampsToDates } from "../helpers/convertGoogleTimeStampsToDates";

export default function formatDefectLogData(
  issues_log,
  issues,
  assigned = "Designers",
) {
  //issues Ids
  const actualIssues = issues
    .filter((issue) => issue["Assigned To"] === assigned)
    .map((issue) => issue.id);

  var runningDefects = [];
  var cleanLog = [];
  issues_log.forEach((log) => {
    if (actualIssues.includes(log.id)) {
      cleanLog.push(log);
    }
  });

  console.log(cleanLog);

  if (cleanLog.length > 0) {
    //start with all defects
    const datesInMilliseconds = issues_log.map((a) =>
      convertGoogleTimeStampsToDates(a.date).getTime(),
    );
    const minTimestamp = Math.min(...datesInMilliseconds);
    const minDate = new Date(minTimestamp);

    var dates = [];
    const currentDate = new Date(
      minDate.getFullYear(),
      minDate.getMonth(),
      minDate.getDate(),
    );
    const endDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
    );

    while (currentDate <= endDate) {
      const dailyDefects = cleanLog.filter((log) => {
        const logDate = convertGoogleTimeStampsToDates(log.date);
        return (
          logDate.toISOString().split("T")[0] ===
          currentDate.toISOString().split("T")[0]
        );
      });

      //update running defects
      dailyDefects.forEach((df) => {
        var existingDefect = runningDefects.find((d) => d.id === df.id);
        //if exists update status,
        if (existingDefect !== undefined) {
          existingDefect.Status = df.Status;
        }
        //else add to running defects
        else {
          runningDefects.push(df);
        }
      });

      // console.log(runningDefects);
      dates.push({
        name: currentDate.toISOString().split("T")[0].slice(5),
        open: runningDefects.filter((d) => d.Status === "Open").length,
        closed: runningDefects.filter((d) => d["Status"].includes("Complete")).length,
        pending: runningDefects.filter((d) => d.Status === "Pending Review").length,
        inprogress: runningDefects.filter((d) => d.Status === "In Progress").length,
      });

      currentDate.setDate(currentDate.getDate() + 1);
    }

    console.log(dates);
    return dates;
  } else {
    return [];
  }
}
